
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: "Breadcrumbs",
})
export default class extends Vue {
  @Prop() items!: any[];
}
